import { Box, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "./epocus-palette";
import { epocusTheme } from "./epocus-theme-provider";

export const PageRoot = styled(Box)({
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 24,
  [epocusTheme.breakpoints.up("sm")]: {
    padding: 24,
    gap: 28,
  },
});

export const Card = styled(Box)({
  backgroundColor: EPOCUS_WHITE,
  borderRadius: 12,
  padding: 16,
  border: `1px solid ${EPOCUS_BORDER}`,
});

export const SectionTitle = styled(Typography)({
  fontSize: rem(15),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
  marginBottom: 12,
});

export const MetaLabel = styled(Typography)({
  fontSize: rem(11),
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase" as const,
  color: EPOCUS_TEXT_SECONDARY,
  marginBottom: 6,
});

export const BigValue = styled(Typography)({
  fontSize: rem(36),
  fontWeight: 700,
  lineHeight: 1,
  color: EPOCUS_TEXT_PRIMARY,
});

/*
 * minmax(0, …) rather than a bare 1fr: a bare fr track floors at the item's
 * min-content width, so one card with wide unwrappable content pushes every
 * track out and the grid overflows the viewport instead of the card wrapping.
 */
export const SummaryGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: 12,
  [epocusTheme.breakpoints.up("sm")]: {
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  },
});
